module.exports = __webpack_public_path__ + "img/icon_multiSign2.78598e63.svg";